import get from "lodash/get";

export const hasPingError = state => get(state, "ping.hasError");
